const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

const buildDepositMethodFormData = (methodData) => {
    const formData = new FormData();
    formData.append('_method', 'PUT');

    Object.entries(methodData).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            return;
        }

        formData.append(key, value);
    });

    return formData;
};

export const updateDepositMethodApi = async (methodId, methodData) => {
    const token = localStorage.getItem('token');

    if (!token) {
        console.error('[updateDepositMethodApi] Ошибка: Токен авторизации не найден.');
  
          // throw new Error('Токен авторизации не найден.');
      }


    const url = `${API_BASE_URL}/admin/lead/deposit-methods/${methodId}`;

    try {
        const response = await fetch(
            url, 
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: buildDepositMethodFormData(methodData),
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || `Ошибка ${response.status}: не удалось обновить метод депозита`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};
